export default "__VITE_ASSET__DLlFlgrX__"